import React from 'react'
import {Tag} from 'antd'
const tagStyle = {color: 'gray'}
const TagsList = ({tags, type = "primary"}) => {
  if (!tags) return null
  return tags.map(tag => <Tag key={tag} style={tagStyle} type={type}><h6>{tag}</h6></Tag>)
}

export default TagsList
